"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSSSEnvironment = exports.getSTMXPrivateBaseHost = void 0;
const STMX_BASE_HOST_MAPPER = {
    'qa-mx-cc': 'https://api.qa.st.mex.opendigitalservices.com',
    'pre-mx-cc': 'https://api.pre.st.mex.opendigitalservices.com',
    'default': 'https://api.dev.st.mex.opendigitalservices.com',
};
const getSTMXPrivateBaseHost = (url) => {
    const { pathname } = new URL(url);
    const envPrefix = pathname.slice(1).split('/')[0];
    return STMX_BASE_HOST_MAPPER[envPrefix] ?? STMX_BASE_HOST_MAPPER.default;
};
exports.getSTMXPrivateBaseHost = getSTMXPrivateBaseHost;
const isSSSEnvironment = () => window.IS_SSS_ENABLED === 'true';
exports.isSSSEnvironment = isSSSEnvironment;
//# sourceMappingURL=url.utils.js.map